import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home/Home";
import "./styles/main.scss"; // Import your main SCSS once
import RoomsPage from "./pages/Rooms/Rooms";
import RoomDetails from "./pages/RoomDetails/RoomDetails";
import Contact from "./pages/Contact/Contact";
import About from "./pages/About/About";
import Navbar from "./components/Navbar/Navbar";
import Booking from "./pages/Booking/Booking";
import ComingSoon from "./pages/ComingSoon/ComingSoon";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { useTranslation } from "react-i18next";
import LumaMenu from "./pages/LumaMenu/LumaMenu";

function AppRoutes() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const decodedPath = decodeURIComponent(location.pathname).toLowerCase();
  const isLumaMenuPage =
    decodedPath === "/lüma-lounge/menu" || decodedPath === "/luma-lounge/menu";

  // Toggle direction based on language
  const currentDir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div dir={currentDir}>
      <ScrollToTop />
      {!isLumaMenuPage && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rooms" element={<RoomsPage />} />
        <Route path="/rooms/:slug" element={<RoomDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/lüma-lounge/menu" element={<LumaMenu />} />
        <Route path="/luma-lounge/menu" element={<LumaMenu />} />
        {/* other routes */}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
